import { Route, Routes } from "react-router-dom";
import React from "react";
import IndexPage from "./page/IndexPage";
import NewPage from "./page/new-page/NewPAge";

const BaseRouter = () => {
    return (
        <Routes>
            {/* New website */}
            <Route exact path="/" element={<NewPage />} />
            {/* <Route exact path="/new-page" element={<IndexPage />} /> */}
        </Routes>
    )
}
export default BaseRouter;